// Etichette del report IVA estera e OSS (features/finance/foreign nel backend)

let regionNames = null;
try {
	regionNames = new Intl.DisplayNames(['it'], { type: 'region' });
} catch (e) {
	regionNames = null;
}

// nome italiano del Paese dal codice ISO ('DE' -> 'Germania'); '??' o vuoto = non indicato
export const countryName = code => {
	if (!code || code === '??') return 'Non indicato';
	try {
		return (regionNames && regionNames.of(code)) || code;
	} catch (e) {
		return code;
	}
};

export const RATE_CLASS = { standard: 'Ordinaria', reduced: 'Ridotta', low: 'Ridotta minima', super: 'Super ridotta' };

export const VIES = {
	valid: { label: 'Valida', color: 'green darken-1' },
	invalid: { label: 'Non valida', color: 'red darken-1' },
	unchecked: { label: 'Da verificare', color: 'orange darken-2' },
};

export const NEXUS = {
	below: { label: 'Sotto soglia', color: 'grey darken-1' },
	near: { label: 'Vicino alla soglia', color: 'orange darken-2' },
	exceeded: { label: 'Soglia superata', color: 'red darken-1' },
	registered: { label: 'Registrato', color: 'green darken-1' },
	notax: { label: 'Senza sales tax', color: 'grey' },
};

// controlli prima della dichiarazione: tipo -> testo
export const ISSUES = {
	missingCountry: { label: 'Paese di spedizione mancante', hint: 'L’ordine resta fra le vendite italiane: correggi l’indirizzo se è partito per l’estero.' },
	uncheckedVat: { label: 'Partita IVA UE da verificare', hint: 'Finché il VIES non risponde la vendita è trattata come B2B non imponibile.' },
	invalidVat: { label: 'Partita IVA non valida al VIES', hint: 'La vendita va in OSS con l’IVA del Paese del cliente.' },
	missingUsState: { label: 'Stato USA mancante', hint: 'L’ordine non entra nelle soglie di nessuno Stato.' },
	approxCurrency: { label: 'Cambio approssimato', hint: 'L’ordine non ha il cambio salvato: si è usato quello attuale del profilo.' },
	unconverted: { label: 'Valuta non convertita', hint: 'Manca il cambio della valuta nel profilo: importo preso così com’è.' },
	reducedRate: { label: 'Aliquota ridotta da confermare', hint: 'L’aliquota ridotta del Paese dipende dalla merce: controllala nelle impostazioni.' },
};

export const quarterLabel = (year, quarter) => (quarter ? `${quarter}° trimestre ${year}` : `Anno ${year}`);
